import * as React from "react";
import { giveFeedback, IFeedbackParams } from "../../services/feedback";
import { useAppContext } from "../../AppContext";
import { FeedbackButtons } from "./FeedbackButtons";

interface IProps {
  articleId: string;
  feedBackTextEnabled?: boolean;
}

export const FeedbackButtonsController = (props: IProps): JSX.Element => {
  const { config, visitorToken } = useAppContext();
  const [newEventId, setNewEventId] = React.useState<string>("");
  const [isSent, setIsSent] = React.useState<boolean>(false);
  const [feedbackText, setFeedbackText] = React.useState<string>("");
  const [isHelpful, setIsHelpful] = React.useState<"default" | "yes" | "no">(
    "default"
  );
  const { articleId, feedBackTextEnabled } = props;
  const defaultParams = {
    articleId,
    src: "SupportCenter",
    kb: config.bold360kb,
    visitorToken,
  };

  const handleYesClick = async () => {
    const params: IFeedbackParams = {
      feedbackType: "positive",
      ...defaultParams,
    };
    setIsHelpful("yes");
    await giveFeedback(config.bold360host, params);
  };

  const handleNoClick = async () => {
    const params: IFeedbackParams = {
      feedbackType: "negative",
      ...defaultParams,
    };
    setIsHelpful("no");
    if (!feedBackTextEnabled) setIsSent(true);
    const res = await giveFeedback(config.bold360host, params);
    if (res.data) setNewEventId(res.data.newEventId);
  };

  const handleSubmit = async (): Promise<void> => {
    const params: IFeedbackParams = {
      prevEventId: newEventId,
      feedbackType: "negative",
      feedbackText,
      ...defaultParams,
    };
    setIsSent(true);
    await giveFeedback(config.bold360host, params);
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    if (e.target.value.length) {
      setFeedbackText(e.target.value);
    }
  };

  return (
    <FeedbackButtons
      isSent={isSent}
      isHelpful={isHelpful}
      onChange={onChange}
      onYesClick={handleYesClick}
      onNoClick={handleNoClick}
      onSubmit={handleSubmit}
      feedBackTextEnabled={props.feedBackTextEnabled || false} //set this to true when we want to turn on the feedback text
    />
  );
};
